export const reportMarketingConsents = (state, action) => {
  const { marketingConsents = {} } = action;
  return {
    ...state,
    marketingConsents,
  };
};
